// const ApiUrl = "http://localhost/manuel_tyre";
const ApiUrl = "https://mrf.aalantechsoft.com/Api";
// const ApiUrl = "http://192.168.112.168 /manuel_tyre";

export default ApiUrl;
